import { render } from "./UserUpdatePage.vue?vue&type=template&id=a3dfd686&scoped=true&ts=true"
import script from "./UserUpdatePage.vue?vue&type=script&lang=ts"
export * from "./UserUpdatePage.vue?vue&type=script&lang=ts"

import "./UserUpdatePage.vue?vue&type=style&index=0&id=a3dfd686&scoped=true&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/QLTS/QLTS_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3dfd686"]])

export default __exports__